import React, { useEffect, useState } from "react";
import Layout from "../../../app/Layout";
import HeaderContent from "../General/HeaderContent";
import Breadcrumb from "../General/Breadcrumb";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faListAlt, faMailBulk, faClipboard, faSearch, faUserPlus, faPhone, faUserCheck, faFire } from "@fortawesome/free-solid-svg-icons";
import DataTable from 'react-data-table-component';
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import { updateStateModalBasic, updateStateModalLarge } from "../../../actions/modalActions";
import ModalBasicwithRedux from "../../../containers/ModalBasicwithRedux";
import FormularioLead from "./FormularioLead";
import FormularioFiltro from "./FormularioFiltro";
import FormularioConversion from "./FormularioConversion";
import FormularioNuevaLlamada from "./FormularioNuevaLlamada";
import "./Trabajadores.scss";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { listarEstados, listarFases, listarObservaciones, registrarClick, filtrarLeads, listarLeads } from "../../../actions/leadsActions";
import { Badge, Modal, Button, Form } from "react-bootstrap";
import EditarLead from "./EditarLead";
import FormularioAsignacionManual from "./FormularioAsignacionManual";
import FormularioFiltroAsesor from "./FormularioFiltroAsesor";
import ResultadosImportacion from "./ResultadosImportacion";
import * as moment from "moment";
import { Link } from "react-router-dom";
import FormularioDatosCorreo from "./FormularioDatosCorreo";
import ModalLargewhithRedux from "../../../containers/ModalLargewhithRedux";
import FormularioNuevoLead from "./FormularioNuevoLead";
import DescargaGoogleContactAsesor from "./ReporteDiario/DescargaGoogleContactAsesor";
import FormularioLeadsDialFire from "./FormularioLeadsDialFire";
import FormularioCambioEstado from "./components/FormularioCambioEstado";

const ListaLeads = () => {
  const dispatch = useDispatch();
  const { leads, loading, respuesta_importacion } = useSelector((state) => state.leads);
  const { usuario } = useSelector((state) => state.usuario);
  const [busqueda, setBusqueda] = useState("");
  const [asignarSeleccion, setSeleccion] = useState(null);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [showModal, setShowModal] = useState(false);

  const nivel_usu = [11, 13];
  const handleChange = (e) => {
    setBusqueda(e.target.value);
  };

  const defaultHiddenColumns = {
    nombre_fuente: true,
    fecha_registro_lead: true,
    nombres: true,
    apellidos: true,
    correo: true,
    notas: true,
    historial: true,
    observacion_n: true,
    tiempo_llamada: true,
    fecha_dialfire: true,
  };

  useEffect(() => {
    dispatch(listarEstados());
    dispatch(listarFases());
    dispatch(listarObservaciones());

    const savedVisibility = localStorage.getItem('columnVisibility');
    if (savedVisibility) {
      setColumnVisibility(JSON.parse(savedVisibility));
    } else {
      // CA02: secondary columns hidden by default
      setColumnVisibility(defaultHiddenColumns);
    }

    // Carga inicial para no-asesores (1=OPERACIONES, 12=MARKETING, 13=JEFE VENTAS)
    // (asesores auto-cargan via FormularioFiltroAsesor)
    if (usuario.id_tp_nivel_usuario !== '11') {
      const savedFilters = localStorage.getItem('filters');
      if (savedFilters) {
        const parsed = JSON.parse(savedFilters);
        if (parsed && parsed.fechaFiltro && parsed.fechaFiltroHasta) {
          const filtersToSend = {
            ...parsed,
            fechaFiltroDesde: moment(parsed.fechaFiltro).format('YYYY-MM-DD'),
            fechaFiltroHasta: moment(parsed.fechaFiltroHasta).format('YYYY-MM-DD'),
          };
          dispatch(filtrarLeads(filtersToSend, usuario));
          return;
        }
      }
      // Sin filtros guardados → cargar mes actual por defecto (rápido)
      const defaultFilters = {
        fechaFiltroDesde: moment().startOf('month').format('YYYY-MM-DD'),
        fechaFiltroHasta: moment().format('YYYY-MM-DD'),
      };
      dispatch(filtrarLeads(defaultFilters, usuario));
    }
  }, [dispatch, usuario]);

  const exportToExcel = () => {
    // Filtrar columnas visibles
    const visibleColumns = columns(handleEditarRegistro, handleRegistrarClick, handleEnviarCorreo, formatTiempo, handleConversion, handleCrearLlamada)
      .filter(column => !columnVisibility[column.selector]);

    // Crear el formato de datos para Excel
    const exportData = leadsBusqueda.map(lead => {
      const rowData = {};
      visibleColumns.forEach(column => {
        rowData[column.name] = lead[column.selector];
      });
      return rowData;
    });

    // Generar el archivo Excel
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Filtrados");

    // Guardar el archivo
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `Leads_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };



  const formatTiempo = (seconds) => {
    let divisor_for_minutes = seconds % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let secs = Math.ceil(divisor_for_seconds);

    return `${minutes < 10 ? "0" + minutes : minutes}:${secs < 10 ? "0" + secs : secs}`;
  };

  const handleModalNuevo = () => {
    dispatch(updateStateModalBasic(<FormularioLead />, "Importar Leads"));
  };

  const handleNuevoLead = () => {
    dispatch(updateStateModalBasic(<FormularioNuevoLead />, "Nuevo lead"));
  };

  const handleDescargarLeads = () => {
    dispatch(updateStateModalLarge(<DescargaGoogleContactAsesor />, "Descargar"));
  };

  const handleEditarRegistro = (registro) => {
    dispatch(updateStateModalBasic(<EditarLead registro={registro} />, "Editar Lead"));
  };

  const handleConversion = (registro) => {
    dispatch(updateStateModalBasic(<FormularioConversion registro={registro} />, "Convertir"));
  };

  const handleCrearLlamada = (registro) => {
    dispatch(updateStateModalBasic(<FormularioNuevaLlamada registro={registro} registros={leads} />, "Programar llamada"));
  };

  const handleEnviarCorreo = (registro) => {
    setTimeout(() => {
      dispatch(updateStateModalLarge(<FormularioDatosCorreo registro={registro} />, "Enviar correo"));
    }, 100);
  };

  const handleRegistrarClick = (registro, tipo) => {
    const datos = {
      autor: usuario.id_usuario,
      id_lead: registro.id_lead,
      tipo: tipo,
    };

    dispatch(registrarClick(datos));
  };

  const handleAsignarManualmente = () => {
    dispatch(updateStateModalBasic(<FormularioAsignacionManual leads={asignarSeleccion.selectedRows} resetSeleccion={setSeleccion} />, "Asignar Leads"));
  };

  const handleImportarDialFire = () => {
    dispatch(updateStateModalBasic(<FormularioLeadsDialFire />, "Importar llamadas"));
  };

  const handleCambiarEstadoGlobal = () => {
    if (asignarSeleccion && asignarSeleccion.selectedRows.length > 0) {
      dispatch(updateStateModalBasic(<FormularioCambioEstado leads={asignarSeleccion.selectedRows} resetSeleccion={setSeleccion} />, "Cambiar Estado"));
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'No hay leads seleccionados',
        text: 'Por favor, selecciona al menos un lead para cambiar su estado.',
      });
    }
  };

  const handleCopyAllVisiblePhones = () => {
    if (asignarSeleccion && asignarSeleccion.selectedRows.length > 0) {
      // Obtener los teléfonos de las filas seleccionadas
      const selectedPhones = asignarSeleccion.selectedRows.map(lead => lead.telefono).join('\n');
      
      // Copiar los números al portapapeles
      navigator.clipboard.writeText(selectedPhones).then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Teléfonos copiados!',
          text: `Se han copiado ${asignarSeleccion.selectedRows.length} teléfonos.`,
          timer: 1500,
          showConfirmButton: false,
        });
      }).catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al copiar los números.',
          timer: 1500,
          showConfirmButton: false,
        });
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'No hay filas seleccionadas',
        text: 'Por favor, seleccione al menos una fila para copiar los números de teléfono.',
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };
  


  const hoy = moment().format('YYYY-MM-DD');

  const stats = leads ? {
    total:        leads.length,
    nuevos:       leads.filter(l => !l.fecha_llamada).length,
    seguimiento:  leads.filter(l => l.fecha_llamada && l.fecha_llamada !== hoy).length,
    gestionados:  leads.filter(l => l.fecha_llamada === hoy).length,
    noContactados: leads.filter(l => l.nombre_estado && l.nombre_estado.toLowerCase().includes('no contesta')).length,
    ventas:       leads.filter(l => l.nombre_estado && l.nombre_estado.toLowerCase().includes('venta')).length,
  } : null;

  const leadsBusqueda = leads
    ? leads
      .filter(
        (lead) =>
          (lead.nombres && lead.nombres.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.apellidos && lead.apellidos.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.correo && lead.correo.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.telefono && lead.telefono.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.observacion_n && lead.observacion_n.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.notas && lead.notas.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.nombre_estado && lead.nombre_estado.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.nombre_proyecto && lead.nombre_proyecto.toLowerCase().includes(busqueda.toLowerCase())) ||
          (lead.historial && lead.historial.toLowerCase().includes(busqueda.toLowerCase()))
      )
      // RN04: orden de prioridad 3 niveles
      // 0 = nuevo pendiente (nunca gestionado)
      // 1 = seguimiento (gestionado antes, no hoy)
      // 2 = gestionado hoy
      .sort((a, b) => {
        const prioridad = (lead) => {
          if (!lead.fecha_llamada) return 0;
          if (lead.fecha_llamada === hoy) return 2;
          return 1;
        };
        return prioridad(a) - prioridad(b);
      })
    : null;

  const toggleColumn = (columnName) => {
    const updatedVisibility = { ...columnVisibility, [columnName]: !columnVisibility[columnName] };
    setColumnVisibility(updatedVisibility);
    localStorage.setItem('columnVisibility', JSON.stringify(updatedVisibility));
  };

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <Layout>
      <div className="Trabajadores">
        <div className="Trabajadores__container">
          <div className="Trabajadores__head">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-1" style={{ gap: '6px' }}>
              <HeaderContent title="Leads" icon="group" />
              <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px' }}>
                {/* Nuevo lead */}
                <button className="btn btn-sm btn-primary" onClick={handleNuevoLead}>
                  <i className="fas fa-plus mr-1"></i>Nuevo lead
                </button>

                {/* Columnas */}
                <button className="btn btn-sm btn-outline-secondary" onClick={handleShowModal}>
                  <i className="fas fa-columns mr-1"></i>Columnas
                </button>

                {/* Importar dropdown */}
                {!nivel_usu.includes(parseInt(usuario.id_tp_nivel_usuario)) && (
                  <div className="dropdown">
                    <button className="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                      <i className="fas fa-file-import mr-1"></i>Importar
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleModalNuevo}>Importar Leads (Excel)</a>
                      <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleImportarDialFire}>Importar DialFire</a>
                    </div>
                  </div>
                )}

                {/* Exportar */}
                <button className="btn btn-sm btn-outline-secondary" onClick={exportToExcel}>
                  <i className="fas fa-file-excel mr-1"></i>Excel
                </button>

                {/* Acciones sobre selección */}
                {asignarSeleccion && asignarSeleccion.selectedCount > 0 && (
                  <div className="dropdown">
                    <button className="btn btn-sm btn-warning dropdown-toggle" type="button" data-toggle="dropdown">
                      {asignarSeleccion.selectedCount} seleccionados
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      {usuario.id_tp_nivel_usuario !== "11" && (
                        <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleAsignarManualmente}>Asignar manualmente</a>
                      )}
                      <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleCambiarEstadoGlobal}>Cambiar estado</a>
                      <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={handleCopyAllVisiblePhones}>Copiar teléfonos</a>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <Breadcrumb
              link={[
                { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
                { url: "", nombre: "Leads" },
              ]}
            />

            {/* Filtro — ancho completo */}
            {usuario.id_tp_nivel_usuario !== "11" ? (
              <FormularioFiltro />
            ) : (
              <FormularioFiltroAsesor />
            )}

            {respuesta_importacion && (
              <ResultadosImportacion resultados={respuesta_importacion} />
            )}
          </div>
          <div className="Trabajadores__body container-fluid px-0 content-actions mt-1">
            <ModalBasicwithRedux />
            <ModalLargewhithRedux />
            <SpinnerLoading loading={loading}>
              <div className="box mt-2">
                <div className="box-header with-border clearfix">
                  <h5 style={{ color: "#434343" }}><FontAwesomeIcon icon={faListAlt} /> Lista de Leads</h5>
                  <div className="col-3 d-flex align-items-center pull-right">
                    <input className="form-control" value={busqueda} onChange={handleChange} style={{ marginRight: "5px" }} placeholder="Filtrar..." />
                    <FontAwesomeIcon icon={faSearch} size="lg" />
                  </div>
                </div>
                {stats && (
                  <div className="d-flex flex-wrap align-items-center px-3 py-2" style={{ gap: '6px', borderBottom: '1px solid #f0f0f0', background: '#fafafa' }}>
                    <StatChip label="Total" value={stats.total} color="#6c757d" />
                    <StatChip label="Nuevos pendientes" value={stats.nuevos} color="#fd7e14" />
                    <StatChip label="Seguimiento" value={stats.seguimiento} color="#6f42c1" />
                    <StatChip label="Gestionados hoy" value={stats.gestionados} color="#28a745" />
                    <StatChip label="No contactados" value={stats.noContactados} color="#dc3545" />
                    <StatChip label="Ventas" value={stats.ventas} color="#007bff" />
                  </div>
                )}
                <div className="box-primary">
                  <DataTable
                    columns={columns(handleEditarRegistro, handleRegistrarClick, handleEnviarCorreo, formatTiempo, handleConversion, handleCrearLlamada).map(column => ({
                      ...column,
                      omit: columnVisibility[column.selector]
                    }))}
                    data={leadsBusqueda}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 65, 75, 85, 100, 200]}
                    selectableRows
                    selectableRowsVisibleOnly
                    onSelectedRowsChange={setSeleccion}
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="60vh"
                  />
                </div>
              </div>
            </SpinnerLoading>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} className="modal-columnas">
        <Modal.Header closeButton>
          <Modal.Title>Configuración de Columnas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {columns(handleEditarRegistro, handleRegistrarClick, handleEnviarCorreo, formatTiempo, handleConversion, handleCrearLlamada).map(column => (
              <Form.Check
                key={column.selector}
                type="switch"
                id={column.selector}
                label={column.name}
                checked={!columnVisibility[column.selector]}
                onChange={() => toggleColumn(column.selector)}
                className="mb-2"
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

const StatChip = ({ label, value, color }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '4px 10px', borderRadius: '20px',
    background: '#fff', border: `1px solid ${color}20`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
  }}>
    <span style={{
      display: 'inline-block', width: '8px', height: '8px',
      borderRadius: '50%', background: color, flexShrink: 0
    }} />
    <span style={{ fontSize: '12px', color: '#666' }}>{label}:</span>
    <span style={{ fontSize: '13px', fontWeight: '700', color }}>{value}</span>
  </div>
);

export default ListaLeads;

/**====================== TABLA =========== */

// CA02: primary columns first, secondary at the end (hidden by default)
const columns = (
  handleEditarRegistro,
  handleRegistrarClick,
  handleEnviarCorreo,
  formatTiempo,
  handleConversion,
  handleCrearLlamada
) => [
    // --- PRIMARY (visible by default) ---
    {
      name: "Nombre",
      selector: "nombre_completo",
      sortable: true,
      wrap: true,
      width: "160px",
      // HU-001 CA-01/CA-05: chip naranja + icono de fuego para leads calientes (lead_caliente = 1)
      cell: (record) => (
        <span>
          {Number(record.lead_caliente) === 1 && (
            <Badge
              pill
              style={{ backgroundColor: '#fd7e14', color: '#fff', marginRight: 6 }}
              title="Lead caliente"
            >
              <FontAwesomeIcon icon={faFire} />
            </Badge>
          )}
          {record.nombres} {record.apellidos}
        </span>
      ),
    },
    {
      name: "Teléfono",
      selector: "telefono",
      align: "center",
      className: "telefono",
      compact: true,
      wrap: true,
      width: "120px",
    },
    {
      name: "Producto",
      selector: "nombre_proyecto",
      align: "center",
      className: "proyecto",
      sortable: true,
      cell: (record) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.3', padding: '4px 0' }}>
          {record.nombre_proyecto}
        </span>
      ),
    },
    {
      name: "Estado",
      selector: "nombre_estado",
      align: "center",
      className: "estado",
      sortable: true,
      width: "130px",
      cell: (record) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.3', padding: '4px 0' }}>
          {record.nombre_estado}
        </span>
      ),
    },
    {
      name: "Asesor",
      selector: "nombre_usuario",
      align: "center",
      className: "nombre_asesor",
      sortable: true,
      width: "120px",
      cell: (record) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.3', padding: '4px 0' }}>
          {record.nombre_usuario}
        </span>
      ),
    },
    {
      name: "Última gestión",
      selector: "fecha_llamada",
      align: "center",
      className: "proyecto",
      sortable: true,
      width: "100px",
    },
    {
      name: "Acciones",
      selector: "Acciones",
      align: "center",
      width: "90px",
      className: "Acciones",
      sortable: false,
      cell: (record) => (
        <div className="d-flex align-items-center" style={{ gap: '4px' }}>
          <Link className="btn btn-warning btn-xs icon-btn" to={`detalleRegistro/${record.id_lead}`} title="Ver / Gestionar">
            <FontAwesomeIcon icon={faEdit} />
          </Link>
          <div className="dropdown">
            <button className="btn btn-secondary btn-xs icon-btn dropdown-toggle" type="button" data-toggle="dropdown" title="Más acciones">
              <i className="fas fa-ellipsis-v" />
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleEnviarCorreo(record)}>
                <FontAwesomeIcon icon={faMailBulk} className="mr-2" />Enviar correo
              </a>
              <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => { handleCopyPhoneNumber(record.telefono); handleRegistrarClick(record, 1); }}>
                <FontAwesomeIcon icon={faClipboard} className="mr-2" />Copiar número
              </a>
              <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleCrearLlamada(record)}>
                <FontAwesomeIcon icon={faPhone} className="mr-2" />Programar llamada
              </a>
              <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleConversion(record)}>
                <FontAwesomeIcon icon={faUserCheck} className="mr-2" />Convertir
              </a>
            </div>
          </div>
        </div>
      ),
    },
    // --- SECONDARY (hidden by default) ---
    {
      name: "Fuente",
      selector: "nombre_fuente",
      className: "fuente",
      width: "130px",
      wrap: true,
    },
    {
      name: "Fecha Registro",
      selector: "fecha_registro_lead",
      align: "center",
      className: "fecha_registro_lead",
      sortable: true,
      width: "150px",
      compact: true,
    },
    {
      name: "Nombres",
      selector: "nombres",
      align: "center",
      sortable: true,
      className: "nombres",
      compact: true,
      wrap: true,
      width: "100px",
    },
    {
      name: "Apellidos",
      selector: "apellidos",
      align: "center",
      sortable: true,
      className: "apellidos",
      compact: true,
      wrap: true,
      width: "100px",
    },
    {
      name: "Correo",
      selector: "correo",
      align: "center",
      className: "correo",
      compact: true,
      wrap: true,
    },
    {
      name: "Notas",
      selector: "notas",
      align: "center",
      className: "notas",
      sortable: true,
      wrap: true,
    },
    {
      name: "Historial",
      selector: "historial",
      align: "center",
      className: "historial",
      sortable: true,
    },
    {
      name: "Observaciones",
      selector: "observacion_n",
      align: "center",
      className: "notas",
      sortable: true,
      wrap: true,
    },
    {
      name: "Duración de llamada",
      selector: "tiempo_llamada",
      align: "center",
      className: "proyecto",
      sortable: true,
      width: "80px",
      cell: (record) => <p>{formatTiempo(record.tiempo_llamada)}</p>,
    },
    {
      name: "Enviado a DialFire",
      selector: "fecha_dialfire",
      align: "center",
      className: "fecha_dialfire",
      sortable: true,
      width: "80px",
    },
  ];

const handleCopyPhoneNumber = (phoneNumber) => {
  navigator.clipboard.writeText(phoneNumber).then(() => {
    Swal.fire({
      icon: 'success',
      title: 'Número copiado!',
      text: `El número ${phoneNumber} ha sido copiado al portapapeles.`,
      timer: 1500,
      showConfirmButton: false,
    });
  }).catch(err => {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Hubo un problema al copiar el número.',
      timer: 1500,
      showConfirmButton: false,
    });
  });
};
